import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const showApiError = (message) => {
  window.dispatchEvent(
    new CustomEvent("api-error", {
      detail: {
        message: message || "Ocurrio un error al procesar la solicitud."
      }
    })
  );
};

// Función centralizada para llamadas API con manejo de token expirado
const repairMojibakeString = (value) => {
  if (!/[ÃÂ]/.test(value)) return value;

  try {
    const bytes = Uint8Array.from(value, (char) => char.charCodeAt(0));
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    return value;
  }
};

const repairMojibake = (value) => {
  if (typeof value === "string") return repairMojibakeString(value);
  if (Array.isArray(value)) return value.map(repairMojibake);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, repairMojibake(item)])
    );
  }

  return value;
};

export function useApi() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);

  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  const apiFetch = useCallback(async (endpoint, method = "GET", body = null, options = {}) => {
    const token = localStorage.getItem("token");
    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: (method.toLowerCase()),
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: body ? JSON.stringify(body) : null
      });

      // Si el token expiró (401 Unauthorized), redirigir al login
      if (response.status === 401 ) {
        localStorage.removeItem("token");
        navigateRef.current("/login");
        throw new Error("se cerró la sesion...");
      }

      // Para otros errores, devolver el error
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      return repairMojibake(await response.json());
    } catch (error) {
      // Si no es un error de token expirado, relanzar el error
     // if (!error.message.includes("Token expirado")) {
      //}
      if (!options.silent) {
        showApiError(error.message);
      }
    }
  }, []);

  return { apiFetch };
}
